import { render, staticRenderFns } from "./Notic1.vue?vue&type=template&id=7350b7b7&scoped=true"
import script from "./Notic1.vue?vue&type=script&lang=js"
export * from "./Notic1.vue?vue&type=script&lang=js"
import style0 from "./Notic1.vue?vue&type=style&index=0&id=7350b7b7&prod&scoped=true&lang=scss"
import style1 from "./Notic1.vue?vue&type=style&index=1&id=7350b7b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7350b7b7",
  null
  
)

export default component.exports